<template>
    <div v-if="!isLoading">
        <v-data-table
            :headers="headers"
            :items="data.results"
            :item-key="itemKey"
            class="elevation-1"
            hide-default-footer
        >
            <template v-slot:item="{ item }">
                <tr>
                    <td
                        class="d-block d-sm-table-cell"
                        v-for="(field, index) in Object.keys(item)"
                        :key="index"
                    >
                        <template
                            v-if="
                                headersExpands.find(header => header === field)
                            "
                            class="expand-panel"
                        >
                            <v-expansion-panels>
                                <v-expansion-panel>
                                    <v-expansion-panel-header>
                                        {{ item[field].value }}
                                    </v-expansion-panel-header>
                                    <v-expansion-panel-content
                                        v-for="(value, index) in item[field]
                                            .expand_values"
                                        :key="index"
                                    >
                                        {{ value.text }}
                                    </v-expansion-panel-content>
                                </v-expansion-panel>
                            </v-expansion-panels>
                        </template>
                        <template v-else>
                            {{ item[field] }}
                        </template>
                    </td>
                </tr>
            </template>
        </v-data-table>

        <md-card-actions
            md-alignment="space-between"
            v-if="isPagination"
            class="container-pagination"
        >
            <div class="">
                <p class="card-category">
                    Mostrando
                    <select id="numberItemPage" v-model="pagination.perPage">
                        <option value="10">10</option>
                        <option value="20">20</option>
                        <option value="40">40</option>
                        <option value="60">60</option>
                        <option value="80">80</option>
                        <option value="100">100</option>
                    </select>
                    itens de um total de {{ total }}.
                </p>
            </div>
            <pagination
                class="pagination-no-border pagination-success"
                v-model="pagination.currentPage"
                :per-page="Number(pagination.perPage)"
                :total="total"
                @input="handlePagination"
            >
            </pagination>
        </md-card-actions>
    </div>

    <div class="text-center pt-3 pb-2" v-else>
        <img src="loader.svg" style="width: 100px; height: 100px" />
    </div>
</template>

<script>
import { Pagination } from '@/components'

export default {
    props: {
        itemKey: {
            type: String,
            require: true
        },

        data: {
            type: Object,
            require: true
        },

        headers: {
            type: [Array],
            require: true
        },

        headersExpands: {
            type: [Array],
            require: false,
            default: () => {
                return []
            }
        },

        isPagination: {
            type: Boolean,
            default: false
        },

        isLoading: {
            type: Boolean,
            default: false
        }
    },

    components: {
        Pagination
    },

    computed: {
        total() {
            return this.data.count
        }
    },

    data() {
        return {
            pagination: {
                perPage: parseInt(process.env.VUE_APP_DEFAULT_PAGE_SIZE),
                currentPage: 1,
                total: 0
            }
        }
    },

    methods: {
        handlePagination(value) {

            this.$emit('handlerPagination', {
                page: value,
                limit: Number(this.pagination.perPage)
            })
        }
    }
}
</script>
<style scoped>
.v-expansion-panel::before {
    box-shadow: none;
    background: transparent;
}

.theme--light.v-expansion-panels .v-expansion-panel {
    background: transparent;
}

.md-card-actions.md-alignment-space-between {
    margin-top: 1px !important;
}

.container-pagination {
    margin-left: 0;
    margin-right: 0;
    border-top: thin solid rgba(0, 0, 0, 0.12);
    align-items: center;
}
</style>
